/**
 * Created by 马荣钦 on 2016/1/21.
 */
angular.module("myZonePersonalInfoLeftModule",[])
    .controller("myZonePersonalInfoLeftCtrl",["$scope",'$state',function($scope,$state){
       initStatus();
       //initData();
       
       function initStatus(){
       		$scope.status ={
       			channel : 1
       		};
          var urlArr = window.location.href.split('/');
          if(urlArr[urlArr.length-1] != 'entermail'){
             $state.go('front.myzone.personalinfo.info');
          }
       }
    }]);